module.exports = __webpack_public_path__ + "first-10-uv_back.jpg?894084f83ebda1d5b4c2c7de918eb9bc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10-uv_back.jpg
// module id = 410
// module chunks = 0